export default "__VITE_ASSET__c25d1bc0__"